import { Grid, Paper, Typography } from '@mui/material'
import { CarrierType, CarrierVisitDirection } from '@planning/app/api'
import { YesNoChipBox } from '@planning/components/dangerous-goods/YesNoChipBox'
import {
  ChangeTransportSubForm,
  ChangeTransportSubFormStore,
} from '@planning/components/organisms/ChangeTransportSubForm'
import { OrderFormStore } from '@planning/pages/Order/V2/stores/OrderFormStore'
import { useTranslate } from '@tolgee/react'
import { FieldBox } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { OrderTransportDuplicateContainerWarning } from '../molecules/OrderTransportDuplicateContainerWarning'

export interface IOrderTransportCardProps {
  title: string
  transportStore: ChangeTransportSubFormStore
  formStore: OrderFormStore
  hideContainerReleasePrompt?: boolean
  direction: CarrierVisitDirection
  isSmallView?: boolean
  disabled?: boolean
}

export const OrderTransportCard: FC<IOrderTransportCardProps> = observer(
  ({
    title,
    transportStore,
    formStore,
    direction,
    hideContainerReleasePrompt,
    isSmallView,
    disabled,
  }) => {
    const { t } = useTranslate()
    const approvalType = direction === CarrierVisitDirection.Inbound ? 'discharge' : 'load'

    const approvalLabel =
      direction === CarrierVisitDirection.Inbound
        ? t('dischargeApproval', 'Discharge approval?')
        : t('loadApproval', 'Load approval?')

    const approvalField =
      direction === CarrierVisitDirection.Inbound
        ? formStore.dischargeApproval
        : formStore.loadApproval

    return (
      <Paper variant='outlined' sx={{ p: '1rem', height: '100%' }}>
        <Grid container direction={'column'} spacing={2}>
          <Grid
            size={{
              sm: 12,
            }}
          >
            <Typography variant='subtitle1'>{title}</Typography>
          </Grid>
          <Grid
            size={{
              sm: 12,
            }}
          >
            <ChangeTransportSubForm
              store={transportStore}
              hideContainerReleasePrompt={hideContainerReleasePrompt}
              isSmallView={isSmallView}
              disabled={disabled}
            />
          </Grid>
          <Grid
            size={{
              sm: 12,
            }}
          >
            {(transportStore.carrierType.value === CarrierType.Vessel ||
              transportStore.carrierType.value === CarrierType.Train) && (
              <FieldBox
                label={approvalLabel}
                displayChildren={false}
                rightRender={
                  <YesNoChipBox
                    activeOption={approvalField.value ? 'Yes' : 'No'}
                    onClickYes={() => approvalField.setValue(true)}
                    onClickNo={() => approvalField.setValue(false)}
                    disableYes={disabled}
                    disableNo={disabled}
                    dataCyYes={`${approvalType}-approval-yes-chip`}
                    dataCyNo={`${approvalType}-approval-no-chip`}
                  />
                }
              />
            )}
          </Grid>
          {transportStore.hasDuplicateContainerConflict && (
            <Grid size={12}>
              <OrderTransportDuplicateContainerWarning />
            </Grid>
          )}
        </Grid>
      </Paper>
    )
  },
)
